import React, { Suspense, lazy } from "react";
import {
    Routes,
    Route,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PrivateRouteAdm from "./PrivateRouteAdm";
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import LoadingPage from "./components/atoms/LoadingPage/LoadingPage";

const Home = lazy(() => import('./pages/Home/index'));
const Details = lazy(() => import('./pages/Details/index'));
const Summary = lazy(() => import('./pages/Summary/index'));
const MyOrders = lazy(() => import('./pages/MyOrders/index'));
const OrderDetail = lazy(() => import('./pages/OrderDetail/index'));
const UserConfirmed = lazy(() => import('./pages/UserConfirmed/index'));
const MyProfile = lazy(() => import('./pages/MyProfile/index'));
const PrescriptionPage = lazy(() => import('./pages/Prescription/index'));
const AdministrationPanel = lazy(() => import('./pages/AdministrationPanel/index'));
const Categories = lazy(() => import('./pages/Administration/Categories/index'));
const SubCategories = lazy(() => import('./pages/Administration/SubCategories/index'));
const Brands = lazy(() => import('./pages/Administration/Brands/index'));
const Products = lazy(() => import('./pages/Administration/Products/index'));
const Orders = lazy(() => import('./pages/Administration/Orders/index'));
const Statistics = lazy(() => import('./pages/Administration/Statistics/index'));
const Prescriptions = lazy(() => import('./pages/Administration/Prescriptions/index'));
const Users = lazy(() => import('./pages/Administration/Users/index'));
const UserDetail = lazy(() => import('./pages/Administration/UserDetail/index'));
const ForgotPasswordConfirmed = lazy(() => import('./pages/ForgotPasswordConfirmed/index'));

export const routes = (
    <TransitionGroup style={{ minHeight: '100%', height: '100%' }}>
        <CSSTransition timeout={500} >
            <Suspense
                fallback={<LoadingPage position={'absolute'} height='100%' />}
            >
                <Routes >
                    {/*Rutas publicas*/}
                    <Route index path="/" element={<Home />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/category/:category_id" element={<Home />} />
                    <Route path="/search/:search" element={<Home />} />
                    <Route path="/home/category/:category_id" element={<Home />} />
                    <Route path="/home/search/:search" element={<Home />} />
                    <Route path="/products/:id" element={<Details />} />
                    <Route path="/confirm-user/:userid/:token" element={<UserConfirmed />} />
                    <Route path="/update-password/:userid/reset-pass/:token" element={<ForgotPasswordConfirmed />} />

                    {/*Rutas privadas*/}
                    <Route path="/summary" element={
                        <PrivateRoute>
                            <Summary />
                        </PrivateRoute>
                    } />
                    <Route path="/my-orders" element={
                        <PrivateRoute>
                            <MyOrders />
                        </PrivateRoute>
                    } />
                    <Route path="/order-detail/:id" element={
                        <PrivateRoute>
                            <OrderDetail />
                        </PrivateRoute>
                    } />
                    <Route path="/administration-panel" element={
                        <PrivateRouteAdm>
                            <AdministrationPanel />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/categories-subcategories" element={
                        <PrivateRouteAdm>
                            <Categories />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/subcategories" element={
                        <PrivateRouteAdm>
                            <SubCategories />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/brands" element={
                        <PrivateRouteAdm>
                            <Brands />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/products" element={
                        <PrivateRouteAdm>
                            <Products />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/orders" element={
                        <PrivateRouteAdm>
                            <Orders />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/statistics" element={
                        <PrivateRouteAdm>
                            <Statistics />
                        </PrivateRouteAdm>
                    } /> 
                    <Route path="/administration-panel/prescriptions" element={
                        <PrivateRouteAdm>
                            <Prescriptions />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/users" element={
                        <PrivateRouteAdm>
                            <Users />
                        </PrivateRouteAdm>
                    } />
                    <Route path="/administration-panel/user-detail/:id" element={
                        <PrivateRoute>
                            <UserDetail />
                        </PrivateRoute>
                    } />
                    <Route path="/my-profile" element={
                        <PrivateRoute>
                            <MyProfile />
                        </PrivateRoute>
                    } />
                    <Route path="/prescription" element={
                        <PrivateRoute>
                            <PrescriptionPage />
                        </PrivateRoute>
                    } />
                    <Route path="*" element={<Home />} />
                </Routes>
            </Suspense>
        </CSSTransition>
    </TransitionGroup>
);